module.exports = __webpack_public_path__ + "img/money.41c89f36.svg";